import { isLocalhost } from '@/utils/origin'

export const isClaudePreview = (): boolean =>
  navigator.userAgent.includes('Claude/') && isLocalhost()

export const isLocalDev = (): boolean => isLocalhost()
